export const SOURCE_OPTIONS = [
  { value: "Website", label: "Website" },
  { value: "Referral", label: "Referral" },
  { value: "Word of mouth", label: "Word of mouth" },
  { value: "Social Media", label: "Social Media" },
];

export const STEPS = [
  "Contact Information",
  "Company/Business Details",
  "Engagement Details",
];

export const TAB_KEYS = [
  "details",
  "communication",
  "client-acceptance",
  "proposals",
  "document-mgt",
];

export const TAB_LABELS = [
  "Detail",
  "Communication",
  "Client Acceptance",
  "Proposals",
  "Document Mgt",
];

export const STATUS_OPTIONS = [
  "Inquiry",
  "Qualified",
  "Contacted",
  "Converted",
  "Closed",
  "Rejected",
];

export const KYC_STEPS = [
  "Company Info",
  "Incase of Others",
  "Engagements",
  "Customer Identification",
];
export const COMMUNICATION_TYPE_OPTIONS = [
  { value: "Email", label: "Email" },
  { value: "SMS", label: "SMS" },
  { value: "Phone Call", label: "Phone Call" },
];

export const KYC_STATUS_OPTIONS = [
  { label: "Pending", value: "pending" },
  { label: "Submitted", value: "submitted" },
  { label: "Under Review", value: "under_review" },
  { label: "KYC Approved", value: "kyc_approved" },
  { label: "Not Approved", value: "not_approved" },
];

